import React, { Component } from "react";
import { message as messageAnt } from "antd";
import MessageContainer from "../modules/message/container";

class AppMessage extends Component {
  componentDidUpdate(prevProps) {
    const { message } = this.props;
    if (message !== prevProps.message && message) {
      messageAnt.success({
        content: message,
        onClose: () => this.props.setMessage(null),
      });
    }
  }
  render() {
    return <></>;
  }
}

export default MessageContainer(AppMessage);
